<template>
<div class="chapter">
<div class="inner_page">
<p class="half-title"><a id="page_1"></a>How to Heal<br/>Toxic Thoughts</p>
<p class="image"><img alt="Image" src="Images/flower.jpg" style="max-width: 100%;"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle01.vue?5dcf4e8a